import React, { useState } from 'react';
import { Modal, Image, Tooltip, theme } from 'antd';
import { FilePdfOutlined, FileImageOutlined, CloseCircleFilled, EditOutlined, FileOutlined, FileExcelOutlined, FileWordOutlined } from '@ant-design/icons';

const AttachmentPreview = ({ file, displayName, showRemove = false, onEdit, show, status }) => {
    const { useToken } = theme

    const { token } = useToken()
    const [open, setOpen] = useState(false);
    const convertToUserStatus = 'convertToUser'
    const isImage = file?.file?.fileType?.startsWith('image/');
    const isPdf = file?.file?.fileType === 'application/pdf';
    const fileType = file?.file?.fileType || '';
    const fileName = file?.file?.fileName?.toLowerCase() || '';
    const isExcel =
        fileType === 'application/vnd.ms-excel' || // .xls
        fileType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || // .xlsx
        fileName.endsWith('.xls') || fileName.endsWith('.xlsx');

    const isWord =
        fileType === 'application/msword' || // .doc
        fileType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || // .docx
        fileName.endsWith('.doc') || fileName.endsWith('.docx');

    const handleView = () => {
        if (isPdf) {
            window.open(file.file.fileLink, '_blank');
        } else if (isImage) {
            setOpen(true);
        } else {
            // Trigger download for other file types
            const link = document.createElement('a');
            link.href = file.file.fileLink;
            link.download = file.file.fileName || 'download';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    const handleEditClick = (e) => {
        e.stopPropagation(); // prevent triggering preview
        if (onEdit) onEdit(file);
    };

    const modalStyles = {
        // header: {
        //     borderLeft: `5px solid ${token.colorPrimary}`,
        //     borderRadius: 0,
        //     paddingInlineStart: 5,
        // },
        // body: {
        //     boxShadow: 'inset 0 0 5px #999',
        //     borderRadius: 5,
        // },
        mask: {
            backdropFilter: 'blur(10px)',
        },
        // footer: {
        //     borderTop: '1px solid #333',
        // },
        // content: {
        //     boxShadow: '0 0 30px #999',
        // },
    };
    return (
        <>
            <div>


                <div
                    onClick={handleView}
                    style={{
                        position: 'relative',
                        cursor: 'pointer',
                        border: '1px solid #ccc',
                        borderRadius: 8,
                        padding: 6,
                        width: 60,
                        height: 60,
                        textAlign: 'center',
                        background: '#fafafa',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                >
                    <Tooltip title={file?.file?.fileName}>

                        {isImage ? (
                            <img
                                src={file?.file?.fileLink}
                                alt={file?.file?.fileName}
                                style={{ maxWidth: '100%', maxHeight: '100%', borderRadius: 4 }}
                            />
                        ) : isPdf ? (
                            <FilePdfOutlined style={{ fontSize: 20, color: 'red' }} />
                        ) : isExcel ? (
                            <FileExcelOutlined style={{ fontSize: 20, color: 'green' }} />
                        ) : isWord ? (
                            <FileWordOutlined style={{ fontSize: 20, color: '#2b579a' }} />
                        ) : (
                            <FileOutlined style={{ fontSize: 20, color: '#8c8c8c' }} />
                        )}
                    </Tooltip>

                    {showRemove && status != convertToUserStatus && (
                        <Tooltip title="Edit">

                            <EditOutlined
                                onClick={handleEditClick}
                                style={{
                                    position: 'absolute',
                                    top: -6,
                                    right: -6,
                                    fontSize: 16,
                                    color: '#1890ff',
                                    background: '#fff',
                                    borderRadius: '50%',
                                    cursor: 'pointer',
                                    boxShadow: '0 0 2px rgba(0,0,0,0.2)'
                                }}
                            />
                        </Tooltip>
                    )}
                </div>
                <Tooltip title={displayName ? displayName : file?.file?.fileName}>

                    <div style={{ fontSize: 10, marginTop: 4, wordBreak: 'break-word', textAlign: 'center' }}>
                        {displayName
                            ? displayName.length > 10
                                ? `${displayName.slice(0, 10)}...`
                                : displayName
                            : file?.file?.fileName?.length > 10
                                ? `${file.file.fileName.slice(0, 10)}...`
                                : file?.file?.fileName}
                    </div>
                </Tooltip>

            </div>

            {isImage && (
                <Modal className='preview-module-candidate-attachment' styles={modalStyles} open={open} footer={null} onCancel={() => setOpen(false)} centered>
                    <Image src={file.file.fileLink} alt={file?.file?.fileName} width="100%" />
                </Modal>
            )}
        </>
    );
};

export default AttachmentPreview;
